import { useEffect } from 'react'
import type { AbstractAgent } from '@copilotkit/react-core/v2'
import useUIStore from 'src/state/stores/ui'

/**
 * Remember the thread as the project's chat once a turn of it starts, so
 * the chat comes back to the conversation last used, however it was left
 * (closed, another project, reload). A fresh thread nobody wrote in is not
 * kept. Reconnecting replays earlier runs through the same callbacks; only a
 * run of this client starts with the run id it sent (`createLiveRunTracker`).
 *
 * A subscription to the agent's event stream: the outside world this effect
 * exists for.
 */
const useRememberThread = (projectId: string, threadId: string, agent: AbstractAgent): void => {
  useEffect(() => {
    const subscription = agent.subscribe({
      onRunStartedEvent: ({ event, input }) => {
        if (event.runId !== input.runId) return
        const { aiChatThreadIdByProject, setAiChatThreadId } = useUIStore.getState()
        if (aiChatThreadIdByProject[projectId] !== threadId) setAiChatThreadId(projectId, threadId)
      },
    })
    return () => subscription.unsubscribe()
  }, [agent, projectId, threadId])
}

export default useRememberThread
